<template>
    <v-dialog v-model="paymentDialog" scrollable persistent max-width="500">
        <v-card>
          <v-card-title>
            <span class="headline"> {{paymentDialogTitle}} Tipo Pagamento</span>
          </v-card-title>
          <v-card-text>
            <v-form>
                <v-container grid-list>
                    <v-layout wrap >
                        <v-flex xs3>
                            <v-text-field
                                v-model="newPaymentType.code"
                                v-validate="'alpha_dash'"
                                :error-messages="errors.first('paymentForm.code')"
                                data-vv-name="code"
                                data-vv-scope="paymentForm"
                                label="Codice"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs9>
                            <v-text-field       
                                ref="firstInput"          
                                v-model="newPaymentType.name"
                                v-validate="'required'"
                                :error-messages="errors.first('paymentForm.name')"
                                data-vv-name="name"
                                data-vv-scope="paymentForm"
                                label="Nome"
                                required    
                            ></v-text-field>                            
                        </v-flex>
                        <v-flex xs6 >
                            <v-select
                                ref="type"
                                v-model="newPaymentType.type"
                                v-validate="'required'"                
                                :items="paymentTypes"
                                :error-messages="errors.first('paymentForm.type')"
                                data-vv-name="type"
                                data-vv-scope="paymentForm"
                                label="Tipo pagamento"                
                                required
                            ></v-select>                            
                        </v-flex>
                        <v-flex xs6 align-items->
                            <v-text-field
                                height='32'
                                mask="##,##"
                                :return-masked-value=true
                                placeholder="00,00"
                                v-model="newPaymentType.price"
                                v-validate="{ rules: { decimal: [2, ','] } }"
                                v-show="checkPayType"
                                :error-messages="errors.first('paymentForm.price')"
                                data-vv-name="price"
                                data-vv-scope="paymentForm"
                                label="Prezzo"
                                suffix= '€'
                                required
                            ></v-text-field>                            
                        </v-flex>
                        <v-flex xs12>
                            <v-combobox
                                v-model="newPaymentType.group"
                                v-validate="'required'"                
                                :items="paymentGroupNames"
                                :error-messages="errors.first('paymentForm.group')"
                                data-vv-name="group"
                                data-vv-scope="paymentForm"
                                label="Gruppo"
                                placeholder="Cerca un gruppo o crea uno nuovo"                
                                required
                            ></v-combobox>                            
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-text-field
                    v-model="newPaymentType.id"
                    v-show=false
                ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" flat @click="closePaymentDialog">Annulla</v-btn>
            <v-btn color="success darken-1" flat @click="savePaymentType">Salva</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import uuidv4 from "uuid/v4";
export default {
    name: 'paymentDialog',
    props: [
        'paymentDialog', 'newPaymentType', 'paymentDialogTitle', 'payments', 'paymentTypes'
    ],
    computed: {
        paymentGroupNames: function(){
            let computedPayments = Object.assign(this.payments);
            let groupArray = computedPayments.filter( (value, index, self) => {
                return index === self.findIndex((element) => {
                    return element.group === value.group; 
                });        
            });

            var mappedGroup = groupArray.map(element => element.group);
            return mappedGroup;
        },
        checkPayType: function(){
            switch (this.newPaymentType.type) {
                case 'tessera':
                    return true;
                case 'ticket':
                    return true;
                default:
                    return false;
            }
        },
        checkDisabled: function(){
            if (this.checkPayType) {
                return '';
            } else {
                return 'price';
            }
        },
    },
    methods: {
        closePaymentDialog() {  
            this.$validator.reset('paymentForm');  
            this.newPaymentType.name = '';
            this.newPaymentType.type = '';
            this.newPaymentType.typeText = '';
            this.newPaymentType.code = '';
            this.newPaymentType.price = '';
            this.newPaymentType.id = '';
            this.newPaymentType.group = '';
            this.$emit('closePaymentDialog', false);
        },
        savePaymentType() {
            let message;
            let done = false;
            let vm = this;

            //workaround to be able to submit form with group combobox not doing the blur event
            setTimeout(() => {
                this.$validator.validate('paymentForm.*').then((result) => {
                    if (result) {
                        if (this.newPaymentType.id) {
                        //find the object in the array served by the DB and update it.
                            this.payments.forEach((payment, index, payments) => {
                                if (payment.id == vm.newPaymentType.id && !done) {
                                    delete vm.newPaymentType.typeText;
                                    if (vm.newPaymentType.price) {
                                        vm.newPaymentType.price = parseFloat(vm.newPaymentType.price.replace(',','.'));
                                    } else {
                                        vm.newPaymentType.price = 0;
                                    }                  
                                    vm.payments.splice(index, 1, utils.clone(vm.newPaymentType));
                                    done = true;
                                }
                            });
                            message = 'Tipo Pagamento modificato. Ricorda di salvare le impostazioni.';               
                        } else {     
                            //push a new object in the object array
                            this.newPaymentType.id = uuidv4();
                            delete this.newPaymentType.typeText;
                            if (vm.newPaymentType.price) {
                                vm.newPaymentType.price = parseFloat(vm.newPaymentType.price.replace(',','.'));
                            } else {
                                vm.newPaymentType.price = 0;
                            }
                            this.payments.push(utils.clone(this.newPaymentType));
                            message = 'Tipo Pagamento inserito. Ricorda di salvare le impostazioni.';         
                        }
                        this.closePaymentDialog();
                        this.$store.dispatch('PUSH_MESSAGE', message);          
                    } 
                });
            });      
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/PaymentDialog.vue